<template>
  <div>
    <button @click="buttonClick">这里是按钮</button>
  </div>
</template>

<script>
    import { MathRandom } from "../../utils/util"
    import { getCurrentDate } from '@/utils/date.js'
export default {
    name: "button-click",
  data() {
    return {

    };
  },
  created() {

  },
  mounted() {

  },
  methods: {
    buttonClick(){
      console.log(`今天是${getCurrentDate()}号`)
        this.$emit("buttonClick",MathRandom())
    }
  }
};
</script>

<style scoped lang="scss">

</style>
